import { OnboardingStepType } from '@alice-financial/alice-sdk'

export type PaygroupDisplayInfo = { id: number; name: string }
export type WithPaygroupInfo = {
  paygroupInfo?: PaygroupDisplayInfo
}

export const HealthcheckType = {
  ...OnboardingStepType,
  EnrollmentSuccess: 'enrollmentSuccess' as const,
} as const

export type HealthcheckType = (typeof HealthcheckType)[keyof typeof HealthcheckType]

export type HealthcheckStatus = 'complete' | 'incomplete' | 'pending' | 'disabled' | 'partial'

export interface HealthcheckAssignee {
  id: number
  name: string
  email?: string | null
  firstName?: string | null
  lastName?: string | null
}

export interface HealthcheckStatusResult {
  status: HealthcheckStatus
  primary: string
  secondary?: string
  details?: string
  assignee?: HealthcheckAssignee | null
  healthcheckType: HealthcheckType
  healthcheckTitle: string
}

export interface HealthcheckRowData
  extends Pick<HealthcheckStatusResult, 'status' | 'primary' | 'secondary' | 'assignee'> {
  id: string // unique identifier for each healthcheck
  healthcheckType: HealthcheckType
  healthcheckTitle: string
  assignee?: HealthcheckAssignee | null
  navigationPath: string | null
  specialAction?: React.ReactElement | null
  org: import('@alice-financial/alice-sdk').OrganizationDetailFragment // for actions that need org context
}

export type OrgHealthcheckSummary = Record<HealthcheckType, HealthcheckStatusResult | undefined>
